import rest from "../script/rest";
import commonUtils from "../script/utils/commonUtils";

class FormatRest {

    async parseFormat(name, file) {
        const url = "/rest/format/parseFormat";
        const response = await rest.file(url, name, file);
        return response.json();
    }

    async uploadFormat(name, siteNum, file) {
        const url = "/rest/format/uploadFormat";
        await rest.file(url, name, file, siteNum);
    }

    async downloadWwjson(calcAreaId) {
        const url = "/rest/format/downloadWwjson"
            + "?calcAreaId=" + calcAreaId;
        await commonUtils.download(url);
    }

    async downloadWwmobile(calcAreaId) {
        const url = "/rest/format/downloadWwmobile"
            + "?calcAreaId=" + calcAreaId;
        await commonUtils.download(url);
    }

    async downloadAustriaExcel(entryId) {
        const url = "/rest/format/downloadAustriaExcel"
            + "?entryId=" + entryId;
        await commonUtils.download(url);
    }
}
const formatRest = new FormatRest();
window.formatRest = formatRest;
export default formatRest;